// useBuild — the deployed build stamp for the Vue app (2026-09-14).
//
// GET /api/health carries `build` = { build: "0.YY.MMDD.HHMM" (UTC, the house
// date/time version), version, commit, builtAt, stamped }. Fetched once per
// page load and shared by every caller, so the front-page footer, and any
// later surface, show the same stamp the vanilla player shows under its Talk
// controls. `label` is the same text the player paints:
//   "build 0.26.0914.0552 · 38b37b1" (+ " (dev, unstamped)" for a local boot).
import { ref, computed } from "vue";

const build = ref(null);
let inflight = null;

export function useBuild() {
  if (!build.value && !inflight) {
    inflight = fetch("/api/health", { credentials: "same-origin" })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { build.value = j?.build || null; })
      .catch(() => { build.value = null; })
      .finally(() => { inflight = null; });
  }
  const label = computed(() => {
    const b = build.value;
    if (!b?.build) return "";
    return `build ${b.build}${b.commit ? ` · ${b.commit}` : ""}${b.stamped === false ? " (dev, unstamped)" : ""}`;
  });
  return { build, label };
}
